import React from "react";
import { Link, useParams } from "react-router-dom";
import services from "../../../data/services.json";

function ServiceDetailsWrapper() {
  const { slug } = useParams();
  const service = services.find(s => s.slug === slug);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!service) {
    return <div>Service not found</div>;
  }

  return (
    <>
      <section className="service-details sec-mar">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-8 col-xl-8 or2">
              <div className="signle-service-details">
                <h3>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icons/service-details-icon.svg"
                    }
                    alt={service.title}
                  />
                  {service.title}
                </h3>
                <p>{service.descriptions.detail}</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 or1">
              <div className="sidebar-search">
                <form
                  onSubmit={(e) => e.preventDefault()}
                  action="#"
                  method="post"
                >
                  <input
                    type="search"
                    name="search"
                    placeholder="Search Here"
                  />
                  <button type="submit">
                    <i className="bi bi-search" />
                  </button>
                </form>
              </div>
              <div className="sidebar-widget">
                <h4>Services</h4>
                <ul className="service-list">
                  {services.map((svc) => (
                    <li key={svc.id}>
                      <Link
                        onClick={scrollTop}
                        to={`${process.env.PUBLIC_URL}/service-details/${svc.slug}`}
                      >
                        <i>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icons/dash-circle-icon.svg"
                            }
                            alt={svc.title}
                          />
                        </i>
                        {svc.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="single-service-work-process">
            <h3>Comment ça marche</h3>
            <div className="single-step">
              <div className="row">
                <div className="col-md-8 col-xl-8 or2">
                  <div className="step">
                    <div className="step-count">
                      <span>01</span>
                    </div>
                    <h4>{service.process.firstStep.name}</h4>
                    <p>{service.process.firstStep.description}</p>
                  </div>
                </div>
                <div className="col-md-4 col-xl-4 or1">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-1.png"}
                      alt={service.process.firstStep.name}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="single-step">
              <div className="row">
                <div className="col-md-4 col-xl-4">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-2.jpg"}
                      alt={service.process.secondStep.name}
                    />
                  </div>
                </div>
                <div className="col-md-8 col-xl-8">
                  <div className="step">
                    <div className="step-count">
                      <span>02</span>
                    </div>
                    <h4>{service.process.secondStep.name}</h4>
                    <p>{service.process.secondStep.description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-step">
              <div className="row">
                <div className="col-md-8 col-xl-8 or2">
                  <div className="step">
                    <div className="step-count">
                      <span>03</span>
                    </div>
                    <h4>{service.process.thirdStep.name}</h4>
                    <p>{service.process.thirdStep.description}</p>
                  </div>
                </div>
                <div className="col-md-4 col-xl-4 or1">
                  <div className="step-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/step-3.jpg"}
                      alt={service.process.thirdStep.name}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceDetailsWrapper;
